import { Injectable } from '@angular/core';
import { EnrichViewer } from '@groupby/enrich-editor';
import { environment } from '../../../environments/environment';
import { Customer } from '../../resources/models/customer.model';

@Injectable()
export class EnrichViewerService {
  public init(customer: Customer) {
    EnrichViewer(customer, environment);
  }
}



// WEBPACK FOOTER //
// ./src/app/editor/services/enrich-viewer.service.ts